<!--
 * @Author: wsx
 * @Date: 2022-01-18 16:17:30
 * @LastEditTime: 2022-02-11 11:33:54
 * @LastEditors: Please set LastEditors
 * @Description:数据字典
-->
<template>
  <el-container class='DataDictionary'>
    <el-card class="role-card" :body-style="treeCard">
      <div class="role-btn">
        <h-button type="primary" @click="addOrgan">添加</h-button>
      </div>
      <el-input
        v-model="filterText"
        placeholder="请输入关键词"
        class="input-with-select"
      >
        <template #prefix>
          <i class="iconfont icon-31sousuo"></i>
        </template>
      </el-input>
      <div class="role-box">
        <div class="role-tr role-header">
          <span class="role-name">名称</span>
          <span class="role-number">类型</span>
        </div>
        <ul>
          <li
            class="role-tr role-item"
            :class="{current:currentDict.type === item.type}"
            v-for="item in dictList"
            :key="item.type"
            @click="currentChange(item)"
          >
            <span class="role-tb role-name">{{item.name}}</span>
            <span class="role-tb role-number">{{item.type}}</span>
          </li>
        </ul>
      </div>
    </el-card>
    <el-card  class="tabs-card">
      <el-row>
        <el-col :span="5">
          <h-button type="primary" @click="addDictVal">添加</h-button>
        </el-col>
      </el-row>
      <h-table
        ref="tableRef"
        v-model:columns="columns"
        :paging="false"
        :method="getDictAsync"
        :params="tableParams"
        @handleClick="handleClick"
        >
      </h-table>
    </el-card>
    <el-dialog
      v-model="dictVisible"
      title="添加/编辑字典"
      width="40%"
    >
      <el-form
        ref="formRef"
        :model="formInline"
        label-width="130px"
        :rules="rules"
        class="demo-dynamic"
      >
        <el-form-item prop="name" label="类型名称">
          <el-input v-model="formInline.name" :disabled="isDisable"></el-input>
        </el-form-item>
        <el-form-item prop="type" label="类型值">
          <el-input v-model="formInline.type" :disabled="isDisable"></el-input>
        </el-form-item>
        <el-form-item prop="value" label="字典名">
          <el-input v-model="formInline.value"></el-input>
        </el-form-item>
        <el-form-item prop="code" label="字典值">
          <el-input v-model="formInline.code"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="formInline.orderNum"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="formInline.remark"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <h-button type="primary" @click="dictSaveAsync">确定</h-button>

          <h-button @click="dictVisible = false">取消</h-button>
        </span>
      </template>
    </el-dialog>
  </el-container>
</template>
<script >
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  watch,
  ref,
  h
} from 'vue';
import { ElMessageBox, ElMessage } from 'element-plus';
import { queryDictList, getDict, dictSave, dictUpdate, dictDelete } from '@/api/constant';
import _ from 'lodash';
export default defineComponent({
  name: 'DataDictionary',
  components: {},
  props: {},
  setup(props) {
    const state = reactive({
      dictVisible: false,
      isInit: false,
      isAdd: true,
      treeCard: {
        height: '100%',
        display: "flex",
        flexDirection: "column"
      },
      currentDict: {},
      dictList: [],
      filterText: '',
      isDisable: false,
      roleListSource: [],
      tableParams: {
        type: ''
      },
      columns: [
        {
          type: "selection"
        },
        {
          label: '名称',
          prop: 'value'
        }, {
          label: '字典值',
          prop: 'code'
        }, {
          type: "operate",
          label: '操作',
          width: '220px',
          operates: [
            { name: '编辑', emitKey: 'edit' },
            { name: '删除', emitKey: 'del', type: 'danger' }
          ]
        }
      ],
      formInline: {
        name: "",
        type: "",
        code: "",
        value: "",
        orderNum: '',
        remark: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入字典名称',
            trigger: 'blur'
          }
        ],
        type: [
          {
            required: true,
            message: '请输入字典类型',
            trigger: 'blur'
          }
        ],
        value: [
          {
            required: true,
            message: '请输入字典码',
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: '请输入字典值',
            trigger: 'blur'
          }
        ]
      }
    });
    const refData = toRefs(state);
    const tableRef = ref();
    const formRef = ref();
    // 组织树的筛选
    watch(() => state.filterText, (v) => {
      state.roleList = state.roleListSource.filter(item => item.name.includes(v));
    });

    // 获取字典类型列表
    const queryData = async () => {
      const res = await queryDictList();
      if (res.code === 0) {
        state.dictList = res.dictList;
        if (state.isInit) {
          currentChange(state.currentDict);
        } else {
          state.isInit = true;
          if (state.dictList[0]) {
            currentChange(state.dictList[0]);
          }
        }
      }
    };
    // 刷新table
    const loadTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 点击table操作按钮
    const handleClick = (operate, row) => {
      const { emitKey } = operate;
      if (emitKey === 'edit') {
        editOrgan(row);
      } else if (emitKey === 'del') {
        delOrgan(row);
      }
    };
    // 获取字典数据
    const getDictAsync = async() => {
      const type = state.tableParams.type;
      let res = {};
      if (type) {
        res = await getDict(type);
      }
      res.page = {
        list: res.dict || []
      };
      return res;
    };
    queryData();
    const dictSaveAsync = async() => {
      formRef.value.validate(async valid => {
        if (valid) {
          let res;
          if (state.isAdd) {
            res = await dictSave(state.formInline);
          } else {
            res = await dictUpdate(state.formInline);
          }
          if (res.code === 0) {
            ElMessage.success(state.isAdd ? '添加成功' : '编辑成功');
            state.dictVisible = false;
            queryData();
          }
        } else {
          return false;
        }
      });
    };
    // 设置当前选中字典类型
    const currentChange = (item) => {
      state.currentDict = item;
      state.tableParams.type = item.type;
      nextTick(() => {
        loadTable();
      });
    };
    // 添加按钮
    const addOrgan = () => {
      resetForm(formRef.value);
      state.isDisable = false;
      state.isAdd = true;
      state.dictVisible = true;
    };
    // 编辑
    const editOrgan = (row) => {
      resetForm(formRef.value);
      state.isDisable = true;
      state.isAdd = false;
      state.dictVisible = true;
      state.formInline = _.cloneDeep(row);
    };
    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
    };

    // 删除角色
    const delOrgan = (row) => {
      ElMessageBox(
        {
          title: '删除',
          message: h('div', { style: "text-align: center;font-size:16px;" }, [
            h('p', null, '您确认要删除该角色吗？'),
            h('p', null, '删除前请确认角色不存在成员（成员数量为0）')
          ]),
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }
      )
        .then(async() => {
          const res = await dictDelete([row.id]);
          if (res.code === 0) {
            ElMessage({
              type: 'success',
              message: '删除成功'
            });
            queryData();
          }
        });
    };
    const addDictVal = () => {
      const { name, type } = state.currentDict;
      state.formInline = { ...state.formInline, name, type };
      state.isDisable = true;
      state.isAdd = true;
      state.dictVisible = true;
    };
    return {
      ...refData,
      tableRef,
      formRef,
      addOrgan,
      handleClick,
      dictSaveAsync,
      getDictAsync,
      currentChange,
      addDictVal
    };
  }
});
</script>
<style  lang='scss' scoped >
.DataDictionary {
    .role-card{
    height: 100%;
    width: 400px;
    .role-btn{
      margin-bottom: 10px;
    }
    .role-box{
      flex: 1;
      overflow: auto;
      position: relative;
      .role-tr{
        line-height: 35px;
        padding: 0 5px;
        box-sizing: border-box;
        @include flex-row-sb-c;
        &.role-item{
          border: 1px solid var(--el-border-color-base);
          margin: 2px 0;
          border-radius: 5px;
          cursor: pointer;
          &:hover,
          &.current{
            background-color: var(--el-color-primary-light-8)
          }
        }
        .role-name{
          width: 50%;
        }
        .role-status{
          width: 20%;
        }
        .role-number{
          width: 30%;
          text-align: right;
        }
      }
      .role-header{
        position: sticky;
        top: 0;
        z-index: 2;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
      }
    }
  }
  .tabs-card{
    flex: 1;
    margin-left: 10px;
  }
}
</style>